/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', or 'unknown'.
 */
export default function getMobileOperatingSystem() {
    const userAgent = (navigator.userAgent ?? '').toLowerCase();
    if (userAgent.includes('android'))
        return 'Android';
    if (['iPhone', 'iPad'].some((platform) => userAgent.includes(platform.toLowerCase()))) {
        return 'iOS';
    }
    return 'unknown';
}
